import axiosInstance from '@/setup/axios/axiosInstance'
import {AreaModel, AreaResponse} from '../models/AreaModel'

// Get all areas
export function getAreas() {
  return axiosInstance.get<AreaResponse>('/areas/')
}

// Get single area by ID
export function getArea(id: number) {
  return axiosInstance.get<AreaModel>(`/areas/${id}/`)
}

// Create new area
export function createArea(areaData: Partial<AreaModel>) {
  return axiosInstance.post<AreaModel>('/areas/', areaData)
}

// Update area
export function updateArea(id: number, areaData: Partial<AreaModel>) {
  return axiosInstance.put<AreaModel>(`/areas/${id}/`, areaData)
}

// Delete area
export function deleteArea(id: number) {
  return axiosInstance.delete(`/areas/${id}/`)
} 